import { ComponentProps } from 'react';
import { createContextualCan } from '@casl/react';
import { AbilityContext } from '../../context/Authorization';

export const Can = createContextualCan(AbilityContext.Consumer);
export type CanProps = ComponentProps<typeof Can>;
